// extracted by css-extract-rspack-plugin
export default {"dateWrapper":"schedule-tile-module__dateWrapper___T4pSL","month":"schedule-tile-module__month___ZRXZ8","date":"schedule-tile-module__date___nRsNj"};